import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AccessibilityWidget from './AccessibilityWidget';
import CookieConsent from './CookieConsent';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <AccessibilityWidget />
      <CookieConsent />
    </div>
  );
};

export default Layout;
